import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';

import { Select2HeaderDirective } from './header.directive';
import { DropdownHeaderComponent } from '../../../../common/dropdown/dropdown-header/dropdown-header.component';

@Component({
  selector: 'rt-select-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Select2HeaderDirective, DropdownHeaderComponent],
  template: `
    <ng-template rtSelectHeader>
      <rt-dropdown-header>
        <ng-container ngProjectAs="[prefix]">
          <ng-content select="[prefix]"></ng-content>
        </ng-container>
        <ng-content></ng-content>
        <ng-container ngProjectAs="[suffix]">
          <ng-content select="[suffix]"></ng-content>
        </ng-container>
      </rt-dropdown-header>
    </ng-template>
  `,
  providers: [
    {
      provide: Select2HeaderDirective,
      useFactory: () => inject(HeaderDefaultComponent).directive(),
    },
  ],
})
export class HeaderDefaultComponent {
  public directive = viewChild.required(Select2HeaderDirective);
}
